"use strict";

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var bbExtend = Backbone.View.extend;
var composeWith = function (parent, sub, newproperties, staticProperties) {
    _.extend(sub, staticProperties);
    _.extend(sub.prototype, newproperties);
    _.each(sub.prototype, function (method, name) {
        var composed;
        if (undefined === method) {
            return; // already handled
        }
        if ("__" === name.substr(-2)) {
            sub.prototype[name] = undefined;
            name = name.slice(0, -2);
            if (_.isArray(method)) {
                composed = sub.prototype[name].concat(method);
            } else if ("object" === typeof method) {
                composed = _.extend({}, sub.prototype[name], method);
            } else {
                composed = function () {
                    var preMethod;
                    var postMethod;
                    var preValue;
                    if (parent.prototype[name]) {
                        preMethod = parent.prototype[name];
                    }
                    postMethod = method;
                    if (preMethod) {
                        preValue = preMethod.apply(this, arguments);
                    }
                    return postMethod.call(this, preValue);
                };
            }
        } else if ("__" === name.substr(0, 2)) {
            sub.prototype[name] = undefined;
            name = name.slice(2);
            if (_.isArray(method)) {
                composed = method.concat(sub.prototype[name]);
            } else if ("object" === typeof method) {
                composed = _.extend({}, method, sub.prototype[name]);
            } else {
                composed = function () {
                    var preMethod = method;
                    var methodReturnVal = preMethod.apply(this, arguments);
                    var postMethod;
                    if (parent.prototype[name]) {
                        postMethod = parent.prototype[name];
                    } else {
                        return methodReturnVal;
                    }
                    return postMethod.call(this, methodReturnVal);
                };
            }
        } else {
            return;
        }
        sub.prototype[name] = composed;
    });
};


/**
 * @mixin extendCompose
 * extendCompose is a drop-in replacement for Backbone.[Model|View|Router|etc...].extend that
 * suports automatic composing of child methods with parent methods.
 * extendCompose offers an alternative to the pattern of calling the parent method directly from a method
 * in your subclass, which can be pretty verbose, for example:
 *
 * <your subclass name>.__super__.<your method name>.apply(this, arguments) // pffew!
 *
 * When you call a method (sans underscore suffix) on a class that's been created using extendCompose:
 *
 * subClassInstance.myMethod(sub, arguments, here)
 *
 * this will happen behind the scenes:
 *
 * subClassInstance.myMethod__(subclassInstance.__super__.myMethod.apply(subClassInstance, [some, arguments, here]))
 *
 * To use it, replace the static extend method of your parent class with extendCompose.
 * Then, in the subclass, for each method that you would like to be automatically composed with
 * the parent's method of the same name (sans unerscore), add a suffix of two underscores to the method's name.
 *
 * example:
 *
 * var extendCompose = require('bunsen/libraries/extendCompose');
 * var ParentClass = Backbone.View.extend({
 *    myMethod : function (firstName, lastName) {
 *       console.log("running ParentClass's myMethod. Arguments are: '" + arguments + "'");
 *       return Array.prototype.slice.call(arguments, 0).join(' ');
 *    }
 * }, { // this section extends static methods
 *    extend: extendCompose
 * });
 * var SubClass = ParentClass.extend({
 *    myMethod__ : function (fullName) { // gets composed with ParentClass.prototype.myMethod
 *       console.log("running SubClass's myMethod. Return value form parent was '" + fullName + "'")
 *    }
 * });
 * var subClass = new SubClass();
 * subClass.myMethod('thomas', 'hallock');
 *
 * the above code will output:
 *
 * running ParentClass's myMethod. Arguments were 'thomas' and 'hallock'
 * running SubClass's myMethod. Return value from Parent was 'thomas hallock'
 *
 * Note: in this example, subclasses of SubClass will inherit extendCompose as well
 *
 */
var ExtendCompose = function () {};
ExtendCompose.prototype.middleware = {
    afterPrototype: function (parentPrototype, childPrototypeBefore, childPrototypeAfter) {
        return childPrototypeAfter; // noop
    }
};
ExtendCompose.prototype.exportBuilder = function () {
    const self = this;
    const ecExport = Object.assign(function (protos, statics) {
        let parent = this;
        let sub;
        if (protos instanceof Array) {
            protos = _.extend.apply(_, [{}].concat(protos));
        }
        sub = bbExtend.call(parent, protos, statics);
        sub.extend = ecExport;
        sub.extendSelf = function () {
            composeWith.apply(this, [parent, sub].concat(Array.prototype.slice.apply(arguments))); // mutates sub
            sub.prototype = self.middleware.afterPrototype(parent.prototype, protos, sub.prototype);
            return sub;
        };
        sub.extendSelf(sub.prototype);
        return sub;
    }, {
        withMiddleware: this.withMiddleware.bind(this)
    });
    return ecExport;
};
ExtendCompose.prototype.withMiddleware = function (middleware) {
    const parentEc = this;
    const NewExtendCompose = Object.assign(function () {}, {
        prototype: this
    });
    const newEc = new NewExtendCompose();
    if (middleware.afterPrototype) {
        newEc.middleware = Object.assign({}, Object.assign({}, parentEc.middleware, {
            afterPrototype: (parentPrototype, childPrototypeBefore, childPrototypeAfter) => middleware.afterPrototype(
                parentPrototype,
                childPrototypeBefore,
                parentEc.middleware.afterPrototype(
                    parentPrototype,
                    childPrototypeBefore,
                    childPrototypeAfter
                )
            )
        }));
    }
    return newEc.exportBuilder();
};
module.exports = new ExtendCompose().exportBuilder();



// WEBPACK FOOTER //
// ./~/bunsen/libraries/extendCompose.es.js